/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_hA_104_65(e) {
  let t = (0, ReactCompiler.c)(8),
    { valor: n, alerta: r } = e,
    i = r !== void 0 && r,
    a = `${n}%`,
    o = i && n < 100 ? `var(--warning)` : `var(--accent)`,
    s;
  t[0] !== a || t[1] !== o
    ? ((s = (
        <div
          className={`h-1.5 w-16 shrink-0 overflow-hidden rounded-full bg-(--panel)`}
          children={
            <div
              className={`h-full rounded-full`}
              style={{
                width: a,
                background: o,
              }}
            />
          }
        />
      )),
      (t[0] = a),
      (t[1] = o),
      (t[2] = s))
    : (s = t[2]);
  let c;
  t[3] === n
    ? (c = t[4])
    : ((c = <span className={`text-xs text-(--text)`} children={[n, `%`]} />),
      (t[3] = n),
      (t[4] = c));
  let l;
  return (
    t[5] !== s || t[6] !== c
      ? ((l = <div className={`flex items-center gap-2`} children={[s, c]} />),
        (t[5] = s),
        (t[6] = c),
        (t[7] = l))
      : (l = t[7]),
    l
  );
}
